import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const ContentBlockStyled = styled.div`
  ${tw`text-white`}

  h1 {
    font-size: 32px;
    line-height: 36px;
    margin: 30px 0;
    font-weight: 700;
  }

  h2 {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    margin: 25px 0;
  }

  h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
    margin: 18px 0;
  }

  ul,
  ol {
    margin-top: 10px;
    margin-left: 25px;
    margin-bottom: 25px;

    li {
      padding-left: 15px;
      margin-bottom: 10px;
    }
  }

  ol {
    list-style: lower-alpha;
  }

  ul {
    list-style: '-';
  }

  p {
    margin-bottom: 30px;
  }

  a {
    text-decoration: underline;
  }
`;

type ContentBlockProps = {
  children: React.ReactNode;
};

const ContentBlock = ({ children }: ContentBlockProps): JSX.Element => {
  return <ContentBlockStyled>{children}</ContentBlockStyled>;
};

export default ContentBlock;
